/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import { AnchorPreferencesObj } from '../types/sizeAdvisor';
import {
  AllProductsInfo,
  SizeQuizGlobalConstants,
  QueryObj,
  AnchorData,
  SizeQuizData
} from '../types/sizeQuiz';
import _ from 'lodash';

const productTypes = SizeQuizGlobalConstants.PRODUCT_TYPES;

// TODO improve this
export default function sizeQuizUtilsDefaultCall(gb) {
  const liquid = gb && gb.liquid;
  const config = gb && gb.config;
  const template = liquid.template;
  const apiUrl = liquid && liquid.apiUrl;
  const brandsNotAllowedForSizeQuiz = window.gb.i18n
    .getText('brands_not_allowed_for_size_quiz')
    .split(',');
    // List of product type to be shown on size quiz screen.
  const PRODUCT_TYPE_OBJ = {
    Dress: true,
    Top: true,
    Pant: true
  };
  let finalResponseObj = {};
  let allProductsInfo = {};
  let productTypeArr = Object.keys(PRODUCT_TYPE_OBJ);
  const numberOfRequest = productTypeArr.length;
  const productTypeArrLen = productTypeArr.length;
  let requestCompletionCounter = 0;
  // contextForSizeQuiz = "SAActivationFlow2",
  const nameSpace = liquid.fSearchNameSpace;
  let sizeChartApiUrl = `${apiUrl}/v1/recommendation/garments/ns/${nameSpace}/sizecharts.json?query=`;
  const isNull = (obj): boolean => obj === null;
  const isUndefined = (obj): boolean => typeof obj === 'undefined';
  const isString = (obj): boolean => typeof obj === 'string';
  // eslint-disable-next-line no-undefined
  const triggerCustomEvent = (el, eventName, options = undefined): void => {
    let event;

    if (window.CustomEvent) {
      event = new CustomEvent(eventName, options);
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(eventName, true, true, options);
    }

    el.dispatchEvent(event);
  };
  const compare = (a, b, desc = false): number => {
    if (a === -1 || b === -1) {
      return 0;
    }

    if (isNull(a) || isUndefined(a)) {
      if (isNull(b) || isUndefined(b)) {
        return 0;
      }

      return 1;
    }

    if (isNull(b) || isUndefined(b)) {
      return -1;
    }

    if (isString(a)) {
      a = a.toLowerCase();
    }

    if (isString(b)) {
      b = b.toLowerCase();
    }

    if (a < b) {
      return desc ? 1 : -1;
    }

    if (a > b) {
      return desc ? -1 : 1;
    }

    return 0;
  };
  const sizeChartSort = (a, b): number => {
    let result = 0;
    let aValue;
    let bValue;
    let maxSuffix = SizeQuizGlobalConstants.MAX_SUFFIX;
    let minSuffix = SizeQuizGlobalConstants.MIN_SUFFIX;
    let presentSuffix = SizeQuizGlobalConstants.PRESENT_SUFFIX;
    let sizePropertyNames = SizeQuizGlobalConstants.SIZE_PROPERTY_NAME;
    let sizeMeasureA = a.sizeMeasure;
    let sizeMeasureB = b.sizeMeasure;

    if (sizePropertyNames[0]) {
      aValue = sizeMeasureA[sizePropertyNames[0] + minSuffix];
      bValue = sizeMeasureB[sizePropertyNames[0] + minSuffix];
      result = compare(aValue, bValue);
    }

    if (result === 0 && sizePropertyNames[1]) {
      aValue = sizeMeasureA[sizePropertyNames[1] + minSuffix];
      bValue = sizeMeasureB[sizePropertyNames[1] + minSuffix];
      result = compare(aValue, bValue);
    }

    if (result === 0 && sizePropertyNames[2]) {
      aValue = sizeMeasureA[sizePropertyNames[2] + minSuffix];
      bValue = sizeMeasureB[sizePropertyNames[2] + minSuffix];
      result = compare(aValue, bValue);
    }

    if (result === 0) {
      result = compare(a.size, b.size);
    }

    return result;
  };
  /**
   * @method - _createProductBrandObj
   * @desc -  create the object with product type as key, by extracting from size chart object.
   * @param - sizeChartsObj - list of object having size charts
   * @param productType {String} - given product type
   * @param productBrandObj {Object} product brand object
   */
  const _createProductBrandObj = (
    sizeChartsObj,
    productType: string,
    productBrandObj
  ): AllProductsInfo | object => {
    let productTypeObj = {};

    // creating product brand object.

    productBrandObj[productType] = productBrandObj[productType] || {};
    productTypeObj = productBrandObj[productType];
    sizeChartsObj.forEach(function (brandInfo) {
      let vendor = brandInfo.vendor;

      if (
        template === 'page.size-quiz' &&
        brandsNotAllowedForSizeQuiz.indexOf(vendor.toLowerCase()) > -1
      ) {
        return;
      }

      productTypeObj[vendor] = productTypeObj[vendor] || {};
      productTypeObj[vendor].brandProperties = brandInfo.brandProperties;
      productTypeObj[vendor].sizes = productTypeObj[vendor].sizes || {};
      productTypeObj[vendor].sortedSizeObject = productTypeObj[vendor].sortedSizeObject || [];

      brandInfo.subVendorAttributes.forEach(function (subVendorInfo) {
        let subVendor = subVendorInfo.subVendor;

        subVendorInfo.categoryAttributes.forEach(function (categoryInfo) {
          let category = categoryInfo.categoryName;
          let sortCategorySizesArray = [];

          categoryInfo.sizeChartDetails.forEach(function (sizeInfo) {
            let size = sizeInfo.size;

            if (!productTypeObj[vendor].sizes[size]) {
              productTypeObj[vendor].sizes[size] = productTypeObj[vendor].sizes[
                size
              ] || {
                type: category,
                subVendor: subVendor
              };

              sortCategorySizesArray.push({
                size: size,
                type: category,
                subVendor: subVendor,
                sizeMeasure: sizeInfo.sizeMeasure,
                sizeQualifier: sizeInfo.sizeQualifier
              });
            }
          });

          if (sortCategorySizesArray && sortCategorySizesArray.length) {
            sortCategorySizesArray.sort(sizeChartSort);
            sortCategorySizesArray.forEach(function (sizeObj) {
              productTypeObj[vendor].sortedSizeObject.push(sizeObj);
            });
          }
        });
      });
    });

    return productBrandObj;
  };
  /**
   * @method - _createProductBrandObjForAllProductType
   * @desc -  for all product type, create the object with product type as key
   * and all brands corresponding to it as value.
   * @return {Object} final object having all product-brand details
   */
  const _createProductBrandObjForAllProductType = (): AllProductsInfo => {
    let key;
    let productBrandObj = {};

    // eslint-disable-next-line no-restricted-syntax
    for (key in finalResponseObj) {
      // eslint-disable-next-line no-prototype-builtins
      if (finalResponseObj.hasOwnProperty(key)) {
        productBrandObj = _createProductBrandObj(
          finalResponseObj[key],
          key,
          productBrandObj
        );
      }
    }

    return productBrandObj;
  };
  // merge all responses as product-brandInfo pairs
  const _mergeAllResponses = (): void => {
    // process only if all responses are successful
    if (Object.keys(finalResponseObj).length === numberOfRequest) {
      allProductsInfo = _createProductBrandObjForAllProductType();
      // store allProductsInfo in local storage
      gb.utils.saveToStore('allProductsInfo', JSON.stringify(allProductsInfo));
    } else {
      // store sizeQuizApiFailed in local storage
      gb.utils.saveToStore('sizeQuizApiFailed', true);
    }

    triggerCustomEvent(document, 'sizeQuizDataFetched');
  };
  // store all responses as product-brandInfo pairs
  const _storeResponseCorrespondingToProductType = (
    response,
    productType: string
  ): void => {
    try {
      let responseObj = JSON.parse(response);

      if (responseObj.status && responseObj.status.code === 0) {
        // store all responses as product-brandInfo pairs
        finalResponseObj[productType] = responseObj.productTypesList[0].vendorAttributesList;
      }
    } catch (e) {
      throw new Error(e);
    }
  };
  /**
   * @method - _updateReqCountAndMergeAllResponseIfAllDone
   * @desc -
   * a) update request count
   * b) merge all responses if all request finished
   */
  const _updateReqCountAndMergeAllResponseIfAllDone = (): void => {
    ++requestCompletionCounter;

    if (requestCompletionCounter === numberOfRequest) {
      _mergeAllResponses();
    }
  };
  /**
   * @method - _fetchSizeChartDataForProductType
   * @desc - fetches the Size Chart data for given product type
   * @param requestUrl {String} - request url
   * @param productType {String} - given product type
   */
  const _fetchSizeChartDataForProductType = (
    requestUrl: string,
    productType: string
  ): void => {
    /**
     * @method - successCallBack
     * @desc -
     * a) update request count and
     * b) store response in storage
     * c) merge all responses if all request finished
     * @param response {Object} - response object from fetch call
     * @param productType {String} - product type
     */
    const successCallBack = (response) => {
      _storeResponseCorrespondingToProductType(response, productType);
      _updateReqCountAndMergeAllResponseIfAllDone();
    };
    const createCORSRequest = (method: string, rUrl: string) => {
      let xhr = new XMLHttpRequest();

      if ('withCredentials' in xhr) {
        xhr.open(method, rUrl, true);
      } else if ((window as any).XDomainRequest !== 'undefined') {
        xhr = new (window as any).XDomainRequest();
        xhr.open(method, rUrl);
      } else {
        xhr = null;
      }

      return xhr;
    };
    const ajaxGetRequestNativeHelper = (rUrl, method, success, failure) => {
      let request = createCORSRequest(method, rUrl);

      if (request) {
        request.withCredentials = true;

        request.onreadystatechange = function () {
          let response;

          if (request.readyState === 4) {
            if (request.status === 200) {
              // the request is complete, parse data and call callback
              response = request.responseText;
              success(response);
            } else {
              // handling for 500 Internal error
              failure();
            }
          }
        };

        request.onerror = function () {
          failure();
        };

        request.send();
      }
    };
    /**
     * @method - errorCallBack
     * @desc -
     * a) update request count
     * b) merge all responses if all request finished
     */
    const errorCallBack = (): void => {
      _updateReqCountAndMergeAllResponseIfAllDone();
    };

    ajaxGetRequestNativeHelper(requestUrl, 'GET', successCallBack, errorCallBack);
  };
  /**
   * @method - _fetchSizeChartDataAndSaveInStore
   * @desc - make parallel request for size quiz data for given product types
   * @param productTypeObj {Object} - given product type Obj
   */
  const _fetchSizeChartDataAndSaveInStore = (): void => {
    let tempUrl;
    let i;
    let queryObj: QueryObj = SizeQuizGlobalConstants.QUERY_OBJ;

    if (sizeChartApiUrl) {
      // make parallel request and store their
      for (i = 0; i < productTypeArrLen; i++) {
        queryObj.productType = productTypeArr[i];
        // queryObj.context = contextForSizeQuiz;
        tempUrl = sizeChartApiUrl + encodeURIComponent(JSON.stringify(queryObj));
        _fetchSizeChartDataForProductType(tempUrl, productTypeArr[i]);
      }
    }
  };
  // get cookie value
  const getCookie = (cname) => {
    let arrCookie;
    let currentCookie;
    let i;
    let name;

    name = cname + '=';
    arrCookie = document.cookie.split(';');

    for (i = 0; i < arrCookie.length; i++) {
      currentCookie = arrCookie[i];

      while (currentCookie.charAt(0) === ' ') {
        currentCookie = currentCookie.substring(1);
      }

      if (currentCookie.indexOf(name) === 0) {
        return currentCookie.substring(name.length, currentCookie.length);
      }
    }

    return '';
  };
  /**
   * Get the data stored with this key in the storage.
   * @param key {String} the key with which the data has been stored.
   * @returns {String} the data stored with this key or empty string.
   */
  const getFromStore = (key: string): string => {
    let value;

    if (window.localStorage) {
      value = localStorage.getItem(key);
    }

    if (!value && window.sessionStorage) {
      value = sessionStorage.getItem(key);
    }

    if (!value) {
      value = getCookie(key);
    }

    return value || '';
  };

  /**
   * @method - fetchSizeQuizDataAndSaveInStore
   * @desc - fetch data required to show size quiz model
   * a) fetch size chart data from sizechart service api and store in local storage
   * @param options {Object}
   */
  // eslint-disable-next-line func-names
  (function fetchSizeQuizDataAndSaveInStore(): void {
    // remove the sizeQuizApiFailed key from storage
    gb.utils.removeFromStore('sizeQuizApiFailed');
    // fetch size chart data and storing in local storage

    let isSizeQuizDataPresentInStore = getFromStore('allProductsInfo');

    if (isSizeQuizDataPresentInStore) {
      triggerCustomEvent(document, 'sizeQuizDataFetched');
    } else {
      _fetchSizeChartDataAndSaveInStore();
    }
  }());
}

/**
 * @name validateContinueButton
 * @desc check whether all fields are set and no dropdown is open currently;
 *       this will decide whether continue btn be disabled or enabled
 */
export const validateContinueButton = (productTypeState): boolean => {
  let flag = true;

  if (productTypeState && !_.isEmpty(productTypeState)) {
    let isBrandAndSizeFilled;
    let curProductTypeState;
    let count = 0;

    _.each(productTypeState, function (val, key) {
      count++;
      curProductTypeState = productTypeState[key];
      isBrandAndSizeFilled = curProductTypeState.anchorSizeBrand &&
        curProductTypeState.anchorSizeBrand.anchorBrand &&
        curProductTypeState.anchorSizeBrand.anchorSize &&
        curProductTypeState.anchorSizeBrand.anchorSize !== '' &&
        curProductTypeState.anchorSizeBrand.anchorSize !== 'undefined';

      if (!isBrandAndSizeFilled) {
        flag = false;
      }
    });

    if (count < productTypes.length) {
      flag = false;
    }
  }

  return flag;
};

export const createSizeRecObject = (anchorDetailsObj, savedSizeObj): AnchorPreferencesObj => {
  let anchorSizeObj;

  _.each(anchorDetailsObj, function (anchorObj, productType) {
    anchorSizeObj = anchorObj.anchorSizeBrand;
    savedSizeObj[productType] = savedSizeObj[productType] || {};
    savedSizeObj[productType].anchorSizeBrand = {
      anchorBrand: decodeURIComponent(anchorSizeObj.anchorBrand),
      anchorSize: decodeURIComponent(anchorSizeObj.anchorSize),
      anchorSubVendor: decodeURIComponent(anchorSizeObj.anchorSubVendor),
      anchorType: decodeURIComponent(anchorSizeObj.anchorType),
      productType: decodeURIComponent(productType)
    };
  });

  return savedSizeObj;
};

/**
 * @ function isAnchorDetailsObjectInvalid
 * @ desc - checking if anchor details obj has all information are filled
 * @ param - anchorDetailsObj {Object}
 * @ return - boolean
 */
export const isAnchorDetailsObjectInvalid = (anchorDetailsObj): boolean => _.some(anchorDetailsObj, function (anchorObj) {
  return (
    _.isEmpty(anchorObj) ||
      _.isEmpty(anchorObj.anchorSizeBrand) ||
      anchorObj.anchorSizeBrand.anchorSize === 'undefined'
  );
});

export const createAnchorPreferencesObject = (
  anchorDetailsObj,
  savedAnchorPreferncesObj,
  curProductType
): SizeQuizData => {
  const productType = curProductType || anchorDetailsObj.productType;

  // eslint-disable-next-line no-param-reassign
  savedAnchorPreferncesObj = savedAnchorPreferncesObj || {};
  savedAnchorPreferncesObj[productType] = savedAnchorPreferncesObj[productType] || {};
  savedAnchorPreferncesObj[productType].anchorSizeBrand = {
    anchorBrand: decodeURIComponent(anchorDetailsObj.anchorBrand),
    anchorSize: decodeURIComponent(anchorDetailsObj.anchorSize),
    anchorSubVendor: decodeURIComponent(anchorDetailsObj.anchorSubVendor),
    anchorType: decodeURIComponent(anchorDetailsObj.anchorType),
    productType: decodeURIComponent(productType)
  };

  return savedAnchorPreferncesObj;
};

export const addCustomEventListener = (el, eventName: string, handler) => {
  if (el.addEventListener) {
    el.addEventListener(eventName, handler);
  } else {
    el.attachEvent('on' + eventName, function () {
      handler.call(el);
    });
  }
};

export const createSizeReqObj = (
  productType: string,
  brand: string,
  size: string | undefined,
  type: string | undefined,
  subVendor: string | undefined
): AnchorData => ({
  anchorBrand: brand,
  anchorSize: size,
  anchorSubVendor: subVendor,
  anchorType: type,
  productType: productType
});
